export enum SftpAccountListColumns {
  SCHOOL_GROUP = 'School Group',
  SCHOOL = 'School',
  GROUP_LEVEL = 'Shared with school group',
  ACTIONS = 'Actions'
}
